// !!! GENERATED FILE !!!
//
export const version = {

  version : "6168M",
  build_time : "2025-03-30 13:01:15",
}

